module.exports = __webpack_public_path__ + "img/76075.08c5f6d6.svg";